<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="
                vx-col
                hidden
                sm:hidden
                md:hidden
                lg:block
                lg:w-1/2
                mx-auto
                self-center
              "
            >
              <img
                src="@/assets/images/pages/reset-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="
                vx-col
                sm:w-full
                md:w-full
                lg:w-1/2
                mx-auto
                self-center
                d-theme-dark-bg
              "
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Change Password</h4>
                  <p>Please enter your new password.</p>
                </div>
                <vs-input
                  name="current password"
                  v-validate="'required|min:8|max:30'"
                  type="password"
                  label-placeholder="Current Password"
                  v-model="currentPassword"
                  class="w-full mb-6"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('current password')"
                  >{{ errors.first("current password") }}</span
                >
                <vs-input
                  name="password"
                  v-validate="'required|min:8|max:15'"
                  ref="password"
                  type="password"
                  label-placeholder="Password"
                  v-model="password"
                  class="w-full mb-6"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('password')"
                  >{{ errors.first("password") }}</span
                >
                <vs-input
                  name="confirm_password"
                  v-validate="'required|min:8|max:15|confirmed:password'"
                  data-vv-as="password"
                  type="password"
                  label-placeholder="Confirm Password"
                  v-model="confirmPassword"
                  class="w-full mb-8"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('confirm_password')"
                  >{{ errors.first("confirm_password") }}</span
                >
                <div
                  class="
                    flex flex-wrap
                    justify-between
                    flex-col-reverse
                    sm:flex-row
                  "
                >
                  <vs-button
                    type="border"
                    to="/pages/login"
                    class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                    >Go Back To Login</vs-button
                  >
                  <vs-button
                    class="w-full sm:w-auto"
                    @click.prevent="changePassword"
                    >Change</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPassword: "",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    changePassword() {
      this.$validator.validateAll().then(result => {

        if (result) {
          // if form have no errors
          const payload = {
            userId: this.$route.params.id,
            currentPassword: this.currentPassword,
            newPassword: this.confirmPassword,
          };
          this.$store
            .dispatch("auth/changePassword", payload)
            .then((res) => {
              var msg =
                res.data.message.code != 1
                  ? "Changed Password Error"
                  : "Changed Password";
              this.$alert(res.data.message.text, msg, res.data.message.type, true)
            })
            .catch((err) => {
              this.$alert(err.response.status, "Changed Password Error", "error");
            });
        } else {
          console.log(result)
          // form have errors
        }
      });
    },
  },
};
</script>
